module.exports = "<p>\n  typeahead works!\n</p>\n"